import Link from "next/link";

const ProfilePhotoButton = ({ image, unreadCount: _unreadCount }) => {
  return (
    <Link href="/account">
      <div className="account-profile-top">
        <div className="profile-photo">
          <div className="profile-photo-cont">{image}</div>
        </div>
        {/*{unreadCount > 0 && <div className="unreadCount">{unreadCount}</div>}*/}
      </div>
    </Link>
  );
};

export default ProfilePhotoButton;
